var angular = require("angular");
var ngModule = angular.module('ct.ui.router.extras.previous', []);
function PreviousStateService($state, $q, $transitions) {
    var previous = null;
    var lastPrevious = null;
    var memos = {};
    $transitions.onStart({}, function ($transition$) {
        var fromState = $transition$.from().$$state();
        function commit() {
            lastPrevious = null;
        }
        function revert() {
            previous = lastPrevious;
        }
        if (fromState) {
            lastPrevious = previous;
            previous = {
                state: $transition$.from(),
                params: $transition$.params('from')
            };
            $transition$.promise.then(commit)['catch'](revert);
        }
    });
    var $previousState = {
        get: function (memoName) {
            return memoName ? memos[memoName] : previous;
        },
        set: function (memoName, previousState, previousParams) {
            memos[memoName] = { state: $state.get(previousState), params: previousParams };
        },
        go: function (memoName, options) {
            var to = $previousState.get(memoName);
            if (!to) {
                return $q.reject(new Error('no previous state ' + (memoName ? 'for memo: ' + memoName : '')));
            }
            return $state.go(to.state, to.params, options);
        },
        memo: function (memoName, defaultStateName, defaultStateParams) {
            memos[memoName] = previous || { state: $state.get(defaultStateName), params: defaultStateParams };
        },
        forget: function (memoName) {
            if (memoName) {
                delete memos[memoName];
            }
            else {
                previous = undefined;
            }
        }
    };
    return $previousState;
}
PreviousStateService.$inject = ['$state', '$q', '$transitions'];
ngModule.service('$previousState', PreviousStateService);



// WEBPACK FOOTER //
// ./src/app/services/previous-state.js